import BillingList from "./pages/BillingList";
import BillingDetail from "./pages/BillingDetail";

import { AppRoute } from "src/types/routes";

export const billingRoutes:AppRoute[] = [
    { path: "billing", element: <BillingList /> },
    { path: "billing/:id", element: <BillingDetail /> }
];

